import { BrandGlyph } from "@aigntx/ui";

/** Animated boot splash — brand mark + rotating ring + name. Shown ~3s on load. */
export function SplashScreen({ exiting = false, name = "AigntX" }: { exiting?: boolean; name?: string }) {
  return (
    <div className={exiting ? "splash is-exiting" : "splash"} role="status" aria-label="Loading">
      <div className="splash__stage">
        <span className="splash__ring" />
        <span className="splash__mark">
          <BrandGlyph id="hexa" size={40} />
        </span>
      </div>
      <div className="splash__name">{name}</div>
      <div className="splash__bar">
        <span />
      </div>
    </div>
  );
}
